@if (!items) {
  <div class="wrapper">
    <places-spinner [small]="true"></places-spinner>
  </div>
} @else {
  @if (items.length > 0) {
    <app-compact-list
      [items]="items"
      [columns]="columns"
      (itemSelected)="itemSelected($event)"
      [isSortable]="false"
      [canToggleColumns]="false"
      [dynamicHeight]="showCurrentAndNearestFuture"
      [hideHeader]="showCurrentAndNearestFuture"
      >
    </app-compact-list>
  } @else {
    <app-feedback-text type="empty">
      <span translate>Could not find vehicle activites for this vehicle</span>
    </app-feedback-text>
  }
}
